<template>
    <div class="min-h-screen">
        <!-- 页面横幅 -->
        <Banner :title="t('contact.banner.title')" :subtitle="t('contact.banner.subtitle')" />

        <!-- 联系方式 -->
        <section class="py-20">
            <div class="container mx-auto px-4">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-[#005005] mb-4 border-b-4 border-[#005005] inline-block pb-2">{{ t('contact.contactInfo.title') }}</h2>
                    <p class="text-[#8d6e63]">{{ t('contact.contactInfo.subtitle') }}</p>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    <div class="bg-white p-8 rounded-lg shadow-lg text-center">
                        <div class="text-4xl text-[#005005] mb-6">
                            <i class="fas fa-map-marker-alt"></i>
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('contact.contactInfo.address.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.contactInfo.address.content') }}</p>
                        <p class="text-[#212121]">{{ t('contact.contactInfo.address.postcode') }}</p>
                    </div>
                    <div class="bg-white p-8 rounded-lg shadow-lg text-center">
                        <div class="text-4xl text-[#005005] mb-6">
                            <i class="fas fa-phone-alt"></i>
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('contact.contactInfo.phone.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.contactInfo.phone.main') }}</p>
                        <p class="text-[#212121]">{{ t('contact.contactInfo.phone.service') }}</p>
                    </div>
                    <div class="bg-white p-8 rounded-lg shadow-lg text-center">
                        <div class="text-4xl text-[#005005] mb-6">
                            <i class="fas fa-envelope"></i>
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('contact.contactInfo.email.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.contactInfo.email.service') }}</p>
                        <p class="text-[#212121]">{{ t('contact.contactInfo.email.inquiry') }}</p>
                    </div>
                    <div class="bg-white p-8 rounded-lg shadow-lg text-center">
                        <div class="text-4xl text-[#005005] mb-6">
                            <i class="fas fa-clock"></i>
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('contact.contactInfo.workingHours.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.contactInfo.workingHours.weekday') }}</p>
                        <p class="text-[#212121]">{{ t('contact.contactInfo.workingHours.holiday') }}</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 在线咨询 -->
        <section class="bg-gray-50 py-20">
            <div class="container mx-auto px-4">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-[#005005] mb-4 border-b-4 border-[#005005] inline-block pb-2">{{ t('contact.inquiry.title') }}</h2>
                    <p class="text-[#8d6e63]">{{ t('contact.inquiry.subtitle') }}</p>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    <div class="lg:col-span-2">
                        <form id="contact-form" @submit.prevent="handleSubmit" class="bg-white p-8 rounded-lg shadow-lg">
                            <div class="mb-6">
                                <label for="name" class="block text-[#8d6e63] font-medium mb-2">{{ t('contact.inquiry.form.name') }} <span class="text-red-500">*</span></label>
                                <input type="text" id="name" v-model="formData.name" required
                                    class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#005005]">
                            </div>
                            <div class="mb-6">
                                <label for="company" class="block text-[#8d6e63] font-medium mb-2">{{ t('contact.inquiry.form.company') }}</label>
                                <input type="text" id="company" v-model="formData.company"
                                    class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#005005]">
                            </div>
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                                <div>
                                    <label for="email" class="block text-[#8d6e63] font-medium mb-2">{{ t('contact.inquiry.form.email') }} <span class="text-red-500">*</span></label>
                                    <input type="email" id="email" v-model="formData.email" required
                                        class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#005005]">
                                </div>
                                <div>
                                    <label for="phone" class="block text-[#8d6e63] font-medium mb-2">{{ t('contact.inquiry.form.phone') }} <span class="text-red-500">*</span></label>
                                    <input type="tel" id="phone" v-model="formData.phone" required
                                        class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#005005]">
                                </div>
                            </div>
                            <div class="mb-6">
                                <label for="subject" class="block text-[#8d6e63] font-medium mb-2">{{ t('contact.inquiry.form.subject') }} <span class="text-red-500">*</span></label>
                                <select id="subject" v-model="formData.subject" required
                                    class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#005005]">
                                    <option value="">{{ t('contact.inquiry.form.subjectPlaceholder') }}</option>
                                    <option value="product">{{ t('contact.inquiry.form.subjects.product') }}</option>
                                    <option value="price">{{ t('contact.inquiry.form.subjects.price') }}</option>
                                    <option value="technical">{{ t('contact.inquiry.form.subjects.technical') }}</option>
                                    <option value="cooperation">{{ t('contact.inquiry.form.subjects.cooperation') }}</option>
                                    <option value="other">{{ t('contact.inquiry.form.subjects.other') }}</option>
                                </select>
                            </div>
                            <div class="mb-6">
                                <label for="message" class="block text-[#8d6e63] font-medium mb-2">{{ t('contact.inquiry.form.message') }} <span class="text-red-500">*</span></label>
                                <textarea id="message" v-model="formData.message" rows="6" required
                                    class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#005005]"></textarea>
                            </div>
                            <div>
                                <button type="submit" :disabled="isSubmitting"
                                    class="w-full bg-[#8d6e63] text-white py-3 px-6 rounded-md hover:bg-[#5f4339] focus:outline-none focus:ring-2 focus:ring-[#005005] focus:ring-offset-2 disabled:bg-[#8d6e63]/50 disabled:cursor-not-allowed transition-colors">
                                    <i v-if="isSubmitting" class="fas fa-spinner fa-spin mr-2"></i>
                                    {{ isSubmitting ? t('contact.inquiry.form.submitting') : t('contact.inquiry.form.submit') }}
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="space-y-6">
                        <div class="bg-white p-6 rounded-lg shadow-lg">
                            <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('contact.inquiry.sales.title') }}</h3>
                            <ul class="space-y-3">
                                <li class="flex justify-between">
                                    <span class="text-[#8d6e63]">{{ t('contact.inquiry.sales.domesticRawPaper') }}：</span>
                                    <span class="text-[#212121]">0831-3309515</span>
                                </li>
                                <li class="flex justify-between">
                                    <span class="text-[#8d6e63]">{{ t('contact.inquiry.sales.domesticFinishedPaper') }}：</span>
                                    <span class="text-[#212121]">0831-3309698</span>
                                </li>
                                <li class="flex justify-between">
                                    <span class="text-[#8d6e63]">{{ t('contact.inquiry.sales.international') }}：</span>
                                    <span class="text-[#212121]">0831-3309530</span>
                                </li>
                                <li class="flex justify-between">
                                    <span class="text-[#8d6e63]">{{ t('contact.inquiry.sales.email') }}：</span>
                                    <span class="text-[#212121]">sales@yb-zy.com</span>
                                </li>
                            </ul>
                        </div>
                        <div class="bg-white p-6 rounded-lg shadow-lg">
                            <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('contact.inquiry.afterSales.title') }}</h3>
                            <ul class="space-y-3">
                                <li class="flex justify-between">
                                    <span class="text-[#8d6e63]">{{ t('contact.inquiry.afterSales.hotlineRawPaper') }}：</span>
                                    <span class="text-[#212121]">0831-3309515</span>
                                </li>
                                <li class="flex justify-between">
                                    <span class="text-[#8d6e63]">{{ t('contact.inquiry.afterSales.hotlineFinishedPaper') }}：</span>
                                    <span class="text-[#212121]">0831-3309698</span>
                                </li>
                                <li class="flex justify-between">
                                    <span class="text-[#8d6e63]">{{ t('contact.inquiry.afterSales.email') }}：</span>
                                    <span class="text-[#212121]">zhongxia@yb-zy.com</span>
                                </li>
                            </ul>
                        </div>
                        <div class="bg-white p-6 rounded-lg shadow-lg">
                            <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('contact.inquiry.social.title') }}</h3>
                            <div class="flex justify-center space-x-8">
                                <a href="#" class="text-[#005005] hover:text-[#005005]/70 transition-colors">
                                    <i class="fab fa-weixin text-2xl mb-2"></i>
                                    <span class="block text-sm">{{ t('contact.inquiry.social.wechat') }}</span>
                                </a>
                                <a href="#" class="text-[#005005] hover:text-[#005005]/70 transition-colors">
                                    <i class="fab fa-weibo text-2xl mb-2"></i>
                                    <span class="block text-sm">{{ t('contact.inquiry.social.weibo') }}</span>
                                </a>
                                <a href="#" class="text-[#005005] hover:text-[#005005]/70 transition-colors">
                                    <i class="fab fa-linkedin text-2xl mb-2"></i>
                                    <span class="block text-sm">{{ t('contact.inquiry.social.linkedin') }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 公司位置 -->
        <section class="py-20">
            <div class="container mx-auto px-4">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-[#005005] mb-4 border-b-4 border-[#005005] inline-block pb-2">{{ t('contact.location.title') }}</h2>
                    <p class="text-[#8d6e63]">{{ t('contact.location.subtitle') }}</p>
                </div>
                <div class="mb-12">
                    <img src="/images/company/6.jpg" :alt="t('contact.location.mapAlt')" class="w-full rounded-lg shadow-lg">
                </div>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div class="flex items-start">
                        <div class="text-2xl text-[#005005] mr-4">
                            <i class="fas fa-subway"></i>
                        </div>
                        <div>
                            <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('contact.location.transport.public.title') }}</h3>
                            <p class="text-[#212121]">{{ t('contact.location.transport.public.content') }}</p>
                        </div>
                    </div>
                    <div class="flex items-start">
                        <div class="text-2xl text-[#005005] mr-4">
                            <i class="fas fa-car"></i>
                        </div>
                        <div>
                            <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('contact.location.transport.driving.title') }}</h3>
                            <p class="text-[#212121]">{{ t('contact.location.transport.driving.content') }}</p>
                        </div>
                    </div>
                    <div class="flex items-start">
                        <div class="text-2xl text-[#005005] mr-4">
                            <i class="fas fa-plane"></i>
                        </div>
                        <div>
                            <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('contact.location.transport.airport.title') }}</h3>
                            <p class="text-[#212121]">{{ t('contact.location.transport.airport.content') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 全球办事处 -->
        <!-- <section class="bg-gray-50 py-20">
            <div class="container mx-auto px-4">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-[#005005] mb-4 border-b-4 border-[#005005] inline-block pb-2">{{ t('contact.offices.title') }}</h2>
                    <p class="text-[#8d6e63]">{{ t('contact.offices.subtitle') }}</p>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    <div class="bg-white p-6 rounded-lg shadow-lg text-center">
                        <div class="mb-4">
                            <img src="/images/36.jfif" :alt="t('contact.offices.china.flagAlt')" class="w-32 h-20 object-cover mx-auto rounded">
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('contact.offices.china.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.offices.china.address') }}</p>
                        <p class="text-[#212121]">{{ t('contact.offices.china.phone') }}</p>
                    </div>
                    <div class="bg-white p-6 rounded-lg shadow-lg text-center">
                        <div class="mb-4">
                            <img src="/images/42.jfif" :alt="t('contact.offices.usa.flagAlt')" class="w-32 h-20 object-cover mx-auto rounded">
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('contact.offices.usa.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.offices.usa.address') }}</p>
                        <p class="text-[#212121]">{{ t('contact.offices.usa.phone') }}</p>
                    </div>
                    <div class="bg-white p-6 rounded-lg shadow-lg text-center">
                        <div class="mb-4">
                            <img src="/images/38.jfif" :alt="t('contact.offices.japan.flagAlt')" class="w-32 h-20 object-cover mx-auto rounded">
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('contact.offices.japan.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.offices.japan.address') }}</p>
                        <p class="text-[#212121]">{{ t('contact.offices.japan.phone') }}</p>
                    </div>
                    <div class="bg-white p-6 rounded-lg shadow-lg text-center">
                        <div class="mb-4">
                            <img src="/images/40.jfif" :alt="t('contact.offices.europe.flagAlt')" class="w-32 h-20 object-cover mx-auto rounded">
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('contact.offices.europe.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.offices.europe.address') }}</p>
                        <p class="text-[#212121]">{{ t('contact.offices.europe.phone') }}</p>
                    </div>
                    <div class="bg-white p-6 rounded-lg shadow-lg text-center">
                        <div class="mb-4">
                            <img src="/images/43.jfif" :alt="t('contact.offices.singapore.flagAlt')" class="w-32 h-20 object-cover mx-auto rounded">
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('contact.offices.singapore.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.offices.singapore.address') }}</p>
                        <p class="text-[#212121]">{{ t('contact.offices.singapore.phone') }}</p>
                    </div>
                </div>
            </div>
        </section> -->

        <!-- 常见问题 -->
        <section class="py-20">
            <div class="container mx-auto px-4">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-[#005005] mb-4 border-b-4 border-[#005005] inline-block pb-2">{{ t('contact.faq.title') }}</h2>
                    <p class="text-[#8d6e63]">{{ t('contact.faq.subtitle') }}</p>
                </div>
                <div class="max-w-3xl mx-auto">
                    <div v-for="(faq, index) in faqs" :key="index" 
                         class="border border-gray-200 rounded-lg mb-4 overflow-hidden"
                         :class="{ 'bg-gray-50': faq.isActive }">
                        <div class="p-4 cursor-pointer flex justify-between items-center"
                             @click="toggleFaq(index)">
                            <h3 class="text-lg font-semibold text-[#005005]">{{ faq.question[locale] }}</h3>
                            <span class="text-[#005005]">
                                <i :class="faq.isActive ? 'fas fa-minus' : 'fas fa-plus'"></i>
                            </span>
                        </div>
                        <div class="px-4 transition-all duration-500 ease-in-out overflow-hidden"
                             :style="{ maxHeight: faq.isActive ? faq.answerHeight + 'px' : '0' }">
                            <div class="py-4 text-[#212121]" v-html="faq.answer[locale]" ref="answerRefs"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <CTA
          :title="t('contact.cta.title')"
          :description="t('contact.cta.description')"
          :buttonText="t('contact.cta.buttonText')"
          buttonLink="#contact-form"
          backgroundImage="/images/56.png"
        />
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import Banner from '../components/Banner.vue'
import CTA from '../components/CTA.vue'

const { t, locale } = useI18n()

// 表单数据
const formData = ref({
    name: '',
    company: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
})

const isSubmitting = ref(false)

interface FAQ {
    question: {
        zh: string
        en: string
        ja: string
        Russian: string
        Malay: string
        Turkish: string
        [key: string]: string
    }
    answer: {
        zh: string
        en: string
        ja: string
        Russian: string
        Malay: string
        Turkish: string
        [key: string]: string
    }
    isActive: boolean
    answerHeight: number
}

// FAQ数据
const faqs = ref<FAQ[]>([
    {
        question: {
            zh: '如何获取产品样品？',
            en: 'How can I request product samples?',
            ja: '製品サンプルのご入手方法',
            Russian: 'Как получить образцы продукции?',
            Malay: 'Bagaimana untuk mendapatkan sampel produk?',
            Turkish: 'Ürün numunesi nasıl alınır?                                                                                                                                      '
        },
        answer: {
            zh: `
                <p>您可以通过以下方式获取产品样品：</p>
                <ol>
                    <li>填写上方的在线咨询表格，选择"产品咨询"，并在咨询内容中注明需要样品的产品型号和用途；</li>
                    <li>直接联系我们的销售团队，电话：0831-3309698；</li>
                    <li>发送邮件至 sales@yb-zy.com，详细说明您的需求。</li>
                </ol>
                <p>收到您的请求后，我们的客服人员将在1-2个工作日内与您联系，确认样品发送事宜。</p>
            `,
            en: `
                <p>You can request samples through the following methods:</p>
                <ol>
                    <li>Fill out the Online Inquiry form above, select "Product Inquiry," and specify the product model and intended use for the sample.</li>
                    <li>Contact our sales team directly at Tel: +86 0831-3309698;</li>
                    <li>Email sales@yb-zy.com with detailed requirements.</li>
                </ol>
                <p>Our customer service will contact you within 1-2 business days to confirm sample shipment upon receiving your request.</p>
            `,
            ja: `
                <p>以下の方法で製品サンプルをご入手いただけます：</p>
                <ol>
                    <li>上部のオンライン相談フォームに「製品相談」を選択の上、サンプルご希望の製品型番と用途をご記入ください；</li>
                    <li>営業チームへ直接お電話ください（電話：0831-3309698）；</li>
                    <li>sales@yb-zy.com までメールにてご要望の詳細をお知らせください。</li>
                </ol>
                <p>ご請求受領後、1-2営業日以内にカスタマーサービスよりご連絡し、サンプル発送の手配をいたします。</p>
            `,
            Russian: `
                <p>Вы можете получить образцы продукции следующими способами:</p>
                <ol>
                    <li>Заполните онлайн-форму выше, выберите "Консультация по продукции" и укажите модель продукта и цель использования;</li>
                    <li>Свяжитесь с отделом продаж по тел: 0831-3309698；</li>
                    <li>Отправьте запрос на sales@yb-zy.com с детальным описанием ваших потребностей.</li>
                </ol>
                <p>После получения запроса наш представитель свяжется с вами в течение 1-2 рабочих дней для подтверждения отправки образцов.</p>
            `,
            Malay: `
                <p>Anda boleh mendapatkan sampel produk melalui cara berikut:</p>
                <ol>
                    <li>Isi borang perundingan dalam talian di atas, pilih "Perundingan Produk", dan nyatakan model produk serta kegunaan sampel yang diperlukan dalam kandungan perundingan;</li>
                    <li>Hubungi terus pasukan jualan kami di talian: 0831-3309698；</li>
                    <li>Hantar e-mel ke sales@yb-zy.com dengan menerangkan keperluan anda secara terperinci.</li>
                </ol>
                <p>Setelah menerima permintaan anda, wakil perkhidmatan pelanggan kami akan menghubungi anda dalam 1-2 hari bekerja untuk mengesahkan penghantaran sampel.</p>
            `,
            Turkish: `
                <p>Ürün numunelerini aşağıdaki yollarla temin edebilirsiniz:</p>
                <ol>
                    <li>Yukarıdaki çevrimiçi danışma formunu doldurun, "Ürün Danışmanlığı" seçeneğini işaretleyin ve talep içeriğinde numune istediğiniz ürün modelini ve kullanım amacını belirtin;</li>
                    <li>Satış ekibimizle doğrudan iletişime geçin, telefon: 0831-3309698；</li>
                    <li> İhtiyaçlarınızı detaylı bir şekilde açıklayan bir e-postayı sales@yb-zy.com adresine gönderin.</li>
                </ol>
                <p>Talebiniz alındıktan sonra, müşteri hizmetleri personelimiz numune gönderim işlemlerini onaylamak için 1-2 iş günü içinde sizinle iletişime geçecektir.</p>
            `
        },
        isActive: false,
        answerHeight: 0
    },
    {
        question: {
            zh: '产品是否可以定制？',
            en: 'Can products be customized?',
            ja: '製品のカスタマイズは可能ですか？',
            Russian: 'Возможна ли кастомизация продукции?',
            Malay: 'Adakah produk boleh disesuaikan?',
            Turkish: 'Ürünler özelleştirilebilir mi?'
        },
        answer: {
            zh: `
                <p>是的，我们提供产品定制服务，可根据客户需求定制产品规格、尺寸、颜色、包装等。定制产品需满足一定的起订量，具体请联系我们的销售团队进行咨询。</p>
            `,
            en: `
                <p>Yes, we offer product customization for specifications, dimensions, colors, packaging, etc., subject to minimum order quantities (MOQ). Please contact our sales team for details.</p>
            `,
            ja: `
                <p>はい、当社ではお客様のご要望に応じて製品仕様、サイズ、色、包装などのカスタマイズが可能です。カスタマイズ製品には最低注文数量がございますので、詳細は営業チームまでお問い合わせください。</p>
            `,
            Russian: `
                <p>Да, мы предлагаем услуги кастомизации под ваши требования (спецификации, размеры, цвета, упаковка). Для индивидуальных заказов действует минимальный объем производства. Подробности уточняйте у отдела продаж.</p>
            `,
            Malay: `
                <p>Ya, kami menyediakan perkhidmatan penyesuaian produk yang boleh menyesuaikan spesifikasi, saiz, warna, pembungkusan mengikut keperluan pelanggan. Pesanan tersuai memerlukan kuantiti pesanan minimum, sila hubungi pasukan jualan kami untuk maklumat lanjut.</p>
            `,
            Turkish: `
                <p>Evet, müşteri ihtiyaçlarına göre ürün özellikleri, boyutları, rengi, ambalajı vb. özelleştirebildiğimiz ürün özelleştirme hizmeti sunuyoruz. Özelleştirilmiş ürünler belirli bir minimum sipariş miktarına tabidir, detaylar için lütfen satış ekibimizle iletişime geçin.</p>
            `
        },
        isActive: false,
        answerHeight: 0
    },
    {
        question: {
            zh: '如何成为宜宾纸业的代理商？',
            en: 'How can I become a Yibin Paper distributor/agent?',
            ja: '宜宾紙業の代理店募集について',
            Russian: 'Как стать агентом Yibin Paper Industry?',
            Malay: 'Bagaimana menjadi ejen Yibin Paper?',
            Turkish: 'Yibin Paper Endüstrisi distribütörü nasıl olunur?                                                                                                                '
        },
        answer: {
            zh: `
                <p>如您有意向成为我们的代理商，请发送合作意向至 ybzy@yb-zy.com，邮件中请包含以下信息：</p>
                <ul>
                    <li>公司基本情况介绍</li>
                    <li>目标市场和客户群体</li>
                    <li>销售渠道和资源</li>
                    <li>合作预期</li>
                </ul>
                <p>我们的业务发展团队将评估您的申请，并在10个工作日内回复。</p>
            `,
            en: `
                <p>If interested in becoming a distributor/agent, please email your proposal to ybzy@yb-zy.com, including the following information:</p>
                <ul>
                    <li>Company background</li>
                    <li>Target market and customer base</li>
                    <li>Sales channels and resources</li>
                    <li>Partnership expectations</li>
                </ul>
                <p>Our business development team will review your application and respond within 10 business days.</p>
            `,
            ja: `
                <p>代理店ご希望の方は、ybzy@yb-zy.com まで以下情報を添えてご連絡ください：</p>
                <ul>
                    <li>貴社の概要</li>
                    <li>ターゲット市場と顧客層</li>
                    <li>販売チャネルとリソース</li>
                    <li>ご要望・ご期待</li>
                </ul>
                <p>弊社業務開発チームにて審査の上、10営業日以内にご返信いたします。</p>
            `,
            Russian: `
                <p>Для рассмотрения кандидатуры отправьте письмо с информацией на ybzy@yb-zy.com:</p>
                <ul>
                    <li>Описание вашей компании</li>
                    <li>Целевые рынки и клиентские группы</li>
                    <li>Каналы сбыта и ресурсы</li>
                    <li>Ожидания от сотрудничества</li>
                </ul>
                <p>Наша команда развития бизнеса рассмотрит заявку и ответит в течение 10 рабочих дней.</p>
            `,
            Malay: `
                <p>Sekiranya anda berminat menjadi ejen kami, sila hantar minat kerjasama ke ybzy@yb-zy.com dengan menyertakan maklumat berikut:</p>
                <ul>
                    <li>Pengenalan asas syarikat</li>
                    <li>Pasaran sasaran dan kumpulan pelanggan</li>
                    <li>Saluran jualan dan sumber</li>
                    <li>Jangkaan kerjasama</li>
                </ul>
                <p>Pasukan pembangunan perniagaan kami akan menilai permohonan anda dan membalas dalam 10 hari bekerja.</p>
            `,
            Turkish: `
                <p>Distribütörümüz olma niyetiniz varsa, lütfen işbirliği niyetinizi ybzy@yb-zy.com adresine e-posta ile gönderin. E-postanızda aşağıdaki bilgileri ekleyin:</p>
                <ul>
                    <li>Şirketinizin temel durumuna ilişkin tanıtım</li>
                    <li>Hedef pazarınız ve müşteri kitleniz</li>
                    <li>Satış kanallarınız ve kaynaklarınız</li>
                    <li>İşbirliği beklentileriniz</li>
                </ul>
                <p> İş geliştirme ekibimiz başvurunuzu değerlendirecek ve 10 iş günü içinde yanıt verecektir.</p>
            `
        },
        isActive: false,
        answerHeight: 0
    },
    {
        question: {
            zh: '产品是否有环保认证？',
            en: 'Are your products environmentally certified?',
            ja: '製品の環境認証について',
            Russian: 'Имеются ли экологические сертификаты на продукцию?',
            Malay: 'Adakah produk mempunyai pensijilan mesra alam?',
            Turkish: ' Ürünlerin çevre dostu sertifikaları var mı?'
        },
        answer: {
            zh: `
                <p>是的，我们的产品已获得多项国内外环保认证，包括FSC认证、ISO 14001环境管理体系认证、中国环境标志产品认证等。您可以在产品详情页查看具体产品的认证信息，或联系我们的客服获取认证证书副本。</p>
            `,
            en: `
                <p>Yes, our products hold multiple domestic and international environmental certifications, including FSC®, ISO 14001, and China Environmental Labeling. Certification details are available on product pages, or contact customer service for copies.</p>
            `,
            ja: `
                <p>はい、FSC認証、ISO 14001環境マネジメントシステム認証、中国環境ラベル製品認証など、国内外の環境認証を取得しております。各製品の認証情報は製品詳細ページでご確認いただくか、カスタマーサービスまでお問い合わせください。</p>
            `,
            Russian: `
                <p>Да, наша продукция имеет международные и национальные сертификаты: FSC, ISO 14001, китайский экологический знак. Подробности на страницах продуктов или у службы поддержки.</p>
            `,
            Malay: `
                <p>Ya, produk kami telah mendapat pelbagai pensijilan alam sekitar domestik dan antarabangsa termasuk FSC, ISO 14001, dan Pensijilan Produk Label Alam Sekitar China. Maklumat pensijilan khusus boleh dilihat di halaman butiran produk atau hubungi perkhidmatan pelanggan kami untuk salinan sijil.</p>
            `,
            Turkish: `
                <p> Evet, ürünlerimiz FSC Sertifikası, ISO 14001 Çevre Yönetim Sistemi Sertifikası, Çin Çevre Etiketi Ürün Sertifikası gibi çok sayıda yerli ve uluslararası çevre dostu sertifikaya sahiptir. Belirli bir ürüne ait sertifika bilgilerini ürün detay sayfasında görebilir veya sertifika kopyası almak için müşteri hizmetlerimizle iletişime geçebilirsiniz.</p>
            `
        },
        isActive: false,
        answerHeight: 0
    },
    {
        question: {
            zh: '公司是否接受参观考察？',
            en: 'Do you accept visits for tours and inspections?',
            ja: '工場見学について',
            Russian: 'Возможны ли посещения предприятия?',
            Malay: 'Adakah syarikat menerima lawatan pemeriksaan?',
            Turkish: 'Şirket ziyaret ve incelemeleri kabul ediyor mu?                                                                                                                  '
        },
        answer: {
            zh: `
                <p>我们欢迎客户、合作伙伴和相关机构前来参观考察。为保证参观质量和安全，请提前至少3个工作日与我们联系预约，邮箱：ybzy@yb-zy.com，或电话：0831-3309663。</p>
            `,
            en: `
                <p>"We welcome visits from customers, partners, and relevant organizations. To ensure quality and safety, please schedule at least 3 business days in advance via email ybzy@yb-zy.com or Tel: +86 0831 3309663."</p>
            `,
            ja: `
                <p>お客様、パートナー様、関連機関様の工場見学を承っております。見学の質と安全確保のため、3営業日前までにご予約ください（メール：ybzy@yb-zy.com、電話：0831-3309663）。</p>
            `,
            Russian: `
                <p>Мы приветствуем визиты клиентов и партнеров. Для организации экскурсии свяжитесь минимум за 3 рабочих дня по email ybzy@yb-zy.com или тел. 0831-3309663.</p>
            `,
            Malay: `
                <p>Kami mengalu-alukan pelanggan, rakan kongsi dan institusi berkaitan untuk lawatan pemeriksaan. Untuk menjamin kualiti dan keselamatan lawatan, sila buat temujanji sekurang-kurangnya 3 hari bekerja lebih awal melalui e-mel: ybzy@yb-zy.com atau telefon: 0831-3309663.</p>
            `,
            Turkish: `
                <p> Müşterileri, iş ortaklarını ve ilgili kuruluşları ziyaret ve inceleme için ağırlamaktan memnuniyet duyarız. Ziyaret kalitesini ve güvenliğini sağlamak için lütfen randevu almak üzere en az 3 iş günü önceden ybzy@yb-zy.com e-posta adresinden veya 0831-3309663 telefon numarasından bizimle iletişime geçin.</p>
            `
        },
        isActive: false,
        answerHeight: 0
    }
])

const answerRefs = ref<HTMLElement[]>([])

// FAQ切换功能
const toggleFaq = (index: number) => {
    // 关闭其他打开的FAQ
    faqs.value.forEach((item, i) => {
        if (i !== index && item.isActive) {
            item.isActive = false
            item.answerHeight = 0
        }
    })
    
    // 切换当前FAQ
    const currentFaq = faqs.value[index]
    currentFaq.isActive = !currentFaq.isActive
    
    if (currentFaq.isActive) {
        // 使用nextTick确保DOM已更新
        nextTick(() => {
            const answerElement = answerRefs.value[index]
            if (answerElement) {
                currentFaq.answerHeight = answerElement.scrollHeight
            }
        })
    } else {
        currentFaq.answerHeight = 0
    }
}

// 表单提交处理
const handleSubmit = async () => {
    isSubmitting.value = true
    
    try {
        // 这里添加表单提交逻辑
        const response = await fetch('http://localhost:3000/api/contact', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData.value)
        })
        
        const data = await response.json()
        
        if (data.success) {
            showMessage('表单提交成功！我们会尽快与您联系。', 'success')
            formData.value = {
                name: '',
                company: '',
                email: '',
                phone: '',
                subject: '',
                message: ''
            }
        } else {
            showMessage(data.message || '提交失败，请稍后重试。', 'error')
        }
    } catch (error) {
        console.error('提交表单时出错:', error)
        showMessage('提交时出现错误，请稍后重试。', 'error')
    } finally {
        isSubmitting.value = false
    }
}

// 显示消息提示
const showMessage = (message: string, type: string = 'info') => {
    // 这里可以添加消息提示组件的实现
    console.log(`${type}: ${message}`)
}

// 平滑滚动功能
onMounted(() => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })

    document.querySelectorAll('.smooth-scroll').forEach(anchor => {
        anchor.addEventListener('click', function(this: HTMLElement, e: Event) {
            e.preventDefault()
            
            const targetId = this.getAttribute('href')
            const targetElement = document.querySelector(targetId || '') as HTMLElement
            
            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - 100,
                    behavior: 'smooth'
                })
            }
        })
    })
})
</script>

<style scoped>
/* 移除所有自定义样式，因为已经使用 Tailwind CSS 类替换 */
</style> 